import { PessoaFisica, PessoaJuridica } from './../pessoa/pessoa.model';

class Assinante {
    AssinanteEstado: string;
    Observacoes: string;
}

export class AssinantePF extends Assinante {
    Id: number; // No modelo o campo é "IDAssinante", utilizando "Id" por limitação do Mock-up
    Pessoa: PessoaFisica;
//    PessoaConjuge: PessoaFisica;
//    PessoaPai: PessoaFisica;
//    PessoaMae: PessoaFisica;
    NomeEmpresaTrabalho: string;
    RendaFamiliar: number;

    constructor() {
        super();
        this.Pessoa = new PessoaFisica;
    }
}

export class AssinantePJ extends Assinante {
    Id: number; // No modelo o campo é "IDAssinante", utilizando "Id" por limitação do Mock-up
    Pessoa: PessoaJuridica;

    constructor() {
        super();
        this.Pessoa = new PessoaJuridica;
    }
}



// WEBPACK FOOTER //
// ./src/app/assinante/assinante.model.ts